import React, { useContext, useState } from "react";
import { ShoppingCart } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { CartContext } from "context/Cart/CartContext";
import LoginModal from "Components/Modal/LoginModal";
import VerificationModal from "Components/Modal/VerificationModal";
import { LoginContext } from "context/Auth/LoginContext";
import { useNavigate } from "react-router-dom";
const Cart = ({ onClick }) => {
  const { cart } = useContext(CartContext);
  const { isLoggedIn, isVerified, user } = useContext(LoginContext);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const navigate = useNavigate();

  const handleCartClick = (e) => {
    if (onClick) {
      onClick();
    }
    if (!isLoggedIn) {
      e.preventDefault();
      setShowLoginModal(true);
    } else if (!isVerified) {
      e.preventDefault();
      setShowVerificationModal(true);
    }
  };

  const handleVerificationLater = () => {
    setShowVerificationModal(false);
    navigate("/");
  };

  const handleVerification = () => {
    navigate("/verify-email", { state: { email: user?.email } });
    setShowVerificationModal(false);
  };

  return (
    <>
      <Link
        className="relative bg-primary text-white px-4 text-xl flex items-center justify-center rounded-md"
        to="/cart"
        onClick={handleCartClick}
      >
        <ShoppingCart />
        <span
          className={`absolute -top-1 right-1 bg-dark text-white p-1 w-4 h-4 flex items-center justify-center rounded-full text-[10px] ${
            isLoggedIn && isVerified ? "opacity-100" : "opacity-0"
          }`}
        >
          {cart.books?.length + cart.courses?.length || 0}
        </span>
      </Link>

      <LoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />

      <VerificationModal
        isOpen={showVerificationModal}
        onClose={handleVerificationLater}
        onVerify={handleVerification}
        email={user?.email}
      />
    </>
  );
};

export default Cart;
